export const projectNewsQueryKeys = {
  all: ["project-news"],
  allWithParams: (limit: number) => [...projectNewsQueryKeys.all, { limit }],
  byId: (id: string | undefined) => [...projectNewsQueryKeys.all, id],
};
